module.exports = __webpack_public_path__ + "img/model-1@2x.fc817b3.png";